export default __webpack_public_path__ + "static/media/activities.a068e72e.svg";